import { Option, SelectOption } from '@/components/form/types';
import { getIconForFieldType } from '@/explore/model/utils';
import { FieldGroup, isFieldGroup } from '@/explore/pipeline/utils';
import { Field } from '@/explore/types';

import styles from './select-options.module.scss';

export const createFieldOption = (field: Field): Option => {
  return {
    label: field.name,
    value: field.key,
    icon: getIconForFieldType(field.type),
    tooltip: <FieldOptionTooltip field={field} />,
  };
};

export const createFieldOptionGrouped = (fieldOrGroup: Field | FieldGroup): SelectOption => {
  if (isFieldGroup(fieldOrGroup)) {
    return {
      value: fieldOrGroup.key,
      label: fieldOrGroup.name ?? '',
      options: fieldOrGroup.fields.map(createFieldOption),
    };
  }
  return createFieldOption(fieldOrGroup);
};

interface FieldOptionTooltipProps {
  field: Field;
}

export const FieldOptionTooltip = (props: FieldOptionTooltipProps) => {
  const { field } = props;
  return (
    <aside className={styles.optionTooltip}>
      <strong className={styles.header}>
        {field.name} <span className={styles.type}>{field.type ?? ''}</span>
      </strong>
      {field.model !== undefined && (
        <p>
          <strong>Model:</strong> {field.model?.name}
        </p>
      )}
      {field.description !== undefined && <p>{field.description}</p>}
    </aside>
  );
};
